import * as types from "../actions/types";

const initialState = {
  data: [],
  loading: false
};

export default function guk_servers(state = initialState, action) {
  switch (action.type) {
    case types.SET_GUK_SERVERS_DATA:
      return {
        ...state,
        data: action.payload
      };
    
    case types.SET_GUK_SERVERS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
  
    default:
      return state;
  }
}



